<script>
	export let name;
</script>


<div class="container">
  <h1><a href="https://www.bungferry.tk/"><em>F</em>erry <em>A</em>yunda</a></h1>
  <p class="slogan"><span>Hello {name}.</span></p>
  <div class="contact">
    <a href="https://www.luhsiapa.tk/" target="_blank"><i class="icon-twitter"></i></a>
    <a href="https://www.facebook.com/bungferry.wa" target="_blank"><i class="icon-facebook"></i></a>
    <a href="https://www.saweria.co/bungferry" target="_blank"><i class="icon-linkedin"></i></a>
    <a href="https://github.com/luhsiapa" target="_blank"><i class="icon-github"></i></a>
  </div>
</div>

